import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQR = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 147,
	fill: "none",
	viewBox: "0 0 100 147",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#43a9f1",
			d: "m2.5 49.24 10.14-2.49c.14-25.6 10.8-39.35 24.02-43.17C11.4 7.88 2.42 28.93 2.49 49.24"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint0_linear_27738_4876)",
			fillOpacity: .38,
			d: "M53.6 59.06c12.87-21.61-2.85-27.5-10.3-26.71 1.39-4.23 7.7-11.18 19.5-5.05 14.75 7.66 9.86 20.37 7.06 26.3-1.37 3.8-17.23 19.64-22.63 27.2-1.48 9.45-1.31 21.47-1.31 21.47l-12.86-3.73c.4-5.31 1.03-16.25 2.05-18.32C38.15 74.04 40 77 53.59 59.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1577bf",
			stroke: "#80a7de",
			strokeWidth: .59,
			d: "M12.55 46.6 2.49 49.4l25.22 2.37 12.84-2.06z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#ddebff",
			strokeWidth: .89,
			d: "m45.93 101.97-12.87-3.43a144 144 0 0 1 1.51-16.37c.8-4.11 4.47-6.67 14.62-17.6 4.69-5.26 12.97-18.42 7.45-25.96-5.85-7.98-12.45-6.22-13.66-5.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint1_linear_27738_4876)",
			stroke: "#ddebff",
			strokeWidth: .59,
			d: "M53.61 2.44c-35.13-4.04-41.9 27.55-40.9 43.85l27.7 3.24c-1.53-17.56 7.06-30.05 22.99-22.18 15.02 7.42 8.14 23.53 6.76 26.25-2.3 4.5-10.56 13.28-16.79 19.66-6.23 6.37-5.84 7.57-6.37 9.47-.44 1.54-.89 13.47-.91 19.25l22.55-.71c.12-2.52-.14-5.2 1.61-12.08 1.76-6.88 18.12-10.4 23.78-26.58C109.4 18.6 71.7 3.99 53.6 2.44Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#ddebff",
			strokeWidth: .89,
			d: "M53.61 2.44c-35.13-4.04-41.9 27.55-40.9 43.85l27.7 3.24c-1.53-17.56 7.06-30.05 22.99-22.18 15.02 7.42 8.14 23.53 6.76 26.25-2.3 4.5-10.56 13.28-16.79 19.66-6.23 6.37-5.84 7.57-6.37 9.47-.44 1.54-.89 13.47-.91 19.25l22.55-.71c.12-2.52-.14-5.2 1.61-12.08 1.76-6.88 18.12-10.4 23.78-26.58C109.4 18.6 71.7 3.99 53.6 2.44Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#ddebff",
			strokeWidth: .89,
			d: "M45.88 102.1 33 98.69a144 144 0 0 1 1.51-16.37c.8-4.11 4.47-6.67 14.62-17.6 4.69-5.26 12.97-18.42 7.45-25.96-5.85-7.98-12.45-6.22-13.66-5.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#add7ff",
			fillOpacity: .43,
			d: "m41 119.94-1.22 25.87 24.32-3.55 1.15-24.24z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#ddebff",
			strokeWidth: .59,
			d: "m28.08 114.44-1.12 23.58 12.82 7.8m0 0L41 119.93l24.25-1.92-1.15 24.24z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#307ec5",
			d: "m27.1 138.1 1.12-23.66 12.64 5.5-1.23 25.86z",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0d1c36",
			fillOpacity: .11,
			stroke: "#ddebff",
			strokeWidth: .89,
			d: "m40.86 119.78-12.92-5.5 22.28-1.17 15.17 5.02z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#ddebff",
			strokeWidth: .89,
			d: "m28.08 114.44-1.12 23.58 12.82 7.8m0 0L41 119.93l24.25-1.92-1.15 24.24z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_27738_4876",
			x1: 56.39,
			x2: 57.27,
			y1: 24.97,
			y2: 94.06,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "#fff",
					stopOpacity: .18
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#ddd"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff",
					stopOpacity: .45
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_27738_4876",
			x1: 93.38,
			x2: 4.77,
			y1: 41.83,
			y2: 19.86,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#fff",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fff",
				stopOpacity: .17
			})]
		})] })
	]
});
export default SvgQR;
